'use client'

import { useMemo } from 'react'
import { getBrowserLanguage } from '~/features/i18n/utils/getBrowserLanguage'
import { isSupportedLanguage } from '~/features/i18n/utils/isSupportedLanguage'
import {
  getLanguageLocalStorage,
  setLanguageLocalStorage,
} from '~/features/i18n/utils/languageLocalStorage'
import { getLanguage } from '~/libs/language'
import { Language } from '~/types/api/users'

export const useMyLanguage = () => {  

  const language: Language = useMemo(() => {
    // if (isLoading) return 'en'
    
    const browserLanguage = getBrowserLanguage()
    const localStorageLanguage = getLanguageLocalStorage()
    const language = getLanguage(typeof window !== 'undefined' ? window.location.hostname : null)
    let selectedLanguage: Language = 'en'

    /**
     * 言語の設定優先順位
     * ① URLのサブドメインに紐づく言語
     * ② ユーザプロフィールに紐づく言語 (ユーザが設定した言語)
     * ③ 設定変更した際に保存したローカルストレージの値 (language)
     * ④ ブラウザのデフォルト言語
     * ⑤ 英語
     */
    if (language) {
      selectedLanguage = language
    } else if (localStorageLanguage && isSupportedLanguage(localStorageLanguage)) {
      selectedLanguage = localStorageLanguage as Language
    } else if (isSupportedLanguage(browserLanguage)) {
      selectedLanguage = browserLanguage as Language
    }

    if (selectedLanguage !== localStorageLanguage) {
      setLanguageLocalStorage(selectedLanguage)
    }

    return selectedLanguage
  }, [])

  return language
}
